import { Injectable } from '@angular/core';
import { InternalSettings } from "../internal-settings/internal-settings.interface"
import { BehaviorSubject, combineLatest } from 'rxjs';
import { ExternalSettingsService } from '../external-settings/external-settings.service';
import { InternalSettingsService } from '../internal-settings/internal-settings.service';
import { ExternalSettings } from '../external-settings/external-settings.interface';
import { ResponsiveDesignService, ScreenType } from '../responsive-design/responsive-design.service';
import { MenuType, PAMenuDesktop, PAMenuMobile } from './pa-menu-meta';
import { PABaseUtility } from './pa-base.utility';
import { Condition_PAMenuDesktop, Condition_PAMenuDesktopTop, Condition_PAMenuMobileView, Condition_PAMenuMobileApp, PAMenuDisplayCondition } from './pa-menu-conditions';

@Injectable({
  providedIn: 'root'
})
export class PermittedActivityService {

  public menuDesktop$: BehaviorSubject<PAMenuDesktop | null> = new BehaviorSubject<PAMenuDesktop | null>(null);
  public menuDesktopTop$: BehaviorSubject<PAMenuDesktop | null> = new BehaviorSubject<PAMenuDesktop | null>(null);
  public menuMobileView$: BehaviorSubject<PAMenuMobile | null> = new BehaviorSubject<PAMenuMobile | null>(null);
  public menuMobileApp$: BehaviorSubject<PAMenuMobile | null> = new BehaviorSubject<PAMenuMobile | null>(null);

  internalSettings!: InternalSettings;
  externalSettings!: ExternalSettings;

  constructor(
    srvEs: ExternalSettingsService,
    srvIs: InternalSettingsService,
    srvRpDesign: ResponsiveDesignService) {

    combineLatest([
      srvEs.externalSettings$,
      srvIs.getCurrentSettings(),
      srvRpDesign.screenType
    ]).subscribe(([es, is, screenType]) => {
      PABaseUtility.init(es, is);
      this.internalSettings = is;
      this.externalSettings = es;
      let conditions = this.initMenuConditions(es.globalVariables.customerWebMenuStyle as MenuType, screenType);
      
      for (const condition of conditions) {
        if (condition.isSatisfied()) {
          condition.buildMenu();
          break;
        }
      }
    })
  }

  /**
   * Entry point to build menu
   */
  private initMenuConditions(menuType: MenuType, screenType: ScreenType): PAMenuDisplayCondition[] {
    return [
      new Condition_PAMenuDesktop(menuType, screenType, this),
      new Condition_PAMenuDesktopTop(menuType, screenType, this),
      new Condition_PAMenuMobileView(menuType, screenType, this),
      new Condition_PAMenuMobileApp(menuType, screenType, this)
    ];
  }
}